import { render, staticRenderFns } from "./Corporations.vue?vue&type=template&id=3515eb0b&scoped=true"
import script from "./Corporations.vue?vue&type=script&lang=js"
export * from "./Corporations.vue?vue&type=script&lang=js"
import style0 from "./Corporations.vue?vue&type=style&index=0&id=3515eb0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3515eb0b",
  null
  
)

export default component.exports